import config from 'const/config'

/**
 * Define global methods which may be executed from the dev tools console to implement application configuration overrides
 */
export const initAppOverrides = () => {
  window.appConfigOverrides = {
    apiHost: config.API_HOST
  } as AppConfigOverrides
}
